"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _ToastStack = _interopRequireDefault(require("../styled/ToastStack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ToastStack = function ToastStack(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ToastStack["default"], {
    theme: theme
  }, children);
};

ToastStack.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node])
};
ToastStack.defaultProps = {
  children: ''
};

var _default = (0, _oxygenConfig.withTheme)(ToastStack, 'toast');

exports["default"] = _default;